module.exports = __webpack_public_path__ + "img/kebab-icon.96cd1285.svg";